import { Grid, TableCell, TableRow } from '@material-ui/core'
import styled from 'styled-components'
import { customTheme } from '../../../../styles/customTheme'
import { Tipografia } from '../../../../components/Tipografia'
import { handleHexToRgba } from '../../../../utils/stringUtils'

export const DetalheControleComissaoPedidoStyles = {
  TableRow: styled(TableRow)`
    background-color: ${handleHexToRgba(0.28, customTheme.colors.grey02)};
    padding: 19px;
  `,
  TableCell: styled(TableCell)`
    padding-bottom: 0px;
    padding-top: 0px;
  `,
  TituloDescricao: styled(Tipografia)`
    margin: 17px 0;
  `,
  ContainerGrid: styled(Grid)`
    padding: 16px 18px;
    margin-bottom: 12px;
  `
}
